import { InformationCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { toast } from "react-toastify";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Modal
} from "shared/components";
import { getErrorMessage } from "utils/error";
import { MhvillageExternalMapping } from "api/mhvillage";
import { useDeleteExternalMapping } from "../api/hooks";

interface DeleteMappingModalProps {
  opened: boolean;
  mapping: MhvillageExternalMapping | null;
  onClose: () => void;
}

export const DeleteMappingModal = ({
  opened,
  mapping,
  onClose
}: DeleteMappingModalProps) => {
  const { mutateAsync, isPending } = useDeleteExternalMapping();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!mapping) return;

    try {
      await mutateAsync(mapping.id);
      toast.success("Mapping deleted");
      onClose();
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[366px] w-full"
    >
      <form onSubmit={handleSubmit} className="relative px-6 pt-8 pb-6">
        <IconButton
          variant={IconButtonVariant.TEXT_BASE}
          size={IconButtonSize.BASE}
          onClick={onClose}
          HugeIcon={Cancel01Icon}
          className="absolute top-6 right-6"
        />

        <div className="flex flex-col items-center text-center">
          <span className="p-4 rounded-full bg-danger-50">
            <HugeiconsIcon
              icon={InformationCircleIcon}
              size="32"
              className="text-danger-500"
            />
          </span>
          <h3 className="mt-4 text-xl font-bold mx-2">
            Are you sure you want to delete this mapping?
          </h3>
          <p className="mt-2 text-sm text-content-400 max-w-[320px]">
            This action cannot be undone
          </p>
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <Button
            size={ButtonSize.BASE}
            onClick={onClose}
            type="button"
            className="w-full"
          >
            Cancel
          </Button>
          <Button
            size={ButtonSize.BASE}
            variant={ButtonVariant.DANGER}
            loading={isPending}
            type="submit"
            className="w-full"
          >
            Delete
          </Button>
        </div>
      </form>
    </Modal>
  );
};
